import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { UpdateLotTransferItem, UpdateLotTransferItemInput, UpdateLotTransferItemVariables } from 'types/graphql';

const UPDATE_LOT_TRANSFER_ITEM = gql`
  mutation UpdateLotTransferItem($id: Int!, $input: UpdateLotTransferItemInput!) {
    updateLotTransferItem(id: $id, input: $input) {
      id
      lot { id slug warehouseId metrics { unitsAvailable } product { description }
        transferredChildren { id slug warehouseId } palletTags { id tagNumber cartonQuantity } }
      palletTagsOnTransferItem { palletTag { id tagNumber cartonQuantity } }
    }
  }
`;
export function useUpdateLotTransferItem() {
  const [mutate, { loading }] = useMutation<UpdateLotTransferItem, UpdateLotTransferItemVariables>(
    UPDATE_LOT_TRANSFER_ITEM
  );
  const update = useCallback(
    async ({ id, input }: { id: number; input: UpdateLotTransferItemInput }) => {
      const result = await mutate({ variables: { id, input } });
      const updated = result.data?.updateLotTransferItem;
      if (!updated) throw new TypeError('The Lot Transfer Item update returned no entity');
      return updated;
    },
    [mutate]
  );
  return { update, loading };
}
